import Box from '@mui/material/Box'
import Markdown from '../Markdown'
import { bodyText } from '../player/playerStyles'

// `points` are added by the server from the shared how-to-use guide.
const HowToUse = ({ block }) => (
  <Box component="ul" sx={{ m: 0, pl: 3, maxWidth: '74ch' }}>
    {(block.points ?? []).map((point, index) => (
      <Box component="li" key={index} sx={{ mb: 1.25, fontSize: '1.0625rem' }}>
        <Markdown sx={bodyText}>{point}</Markdown>
      </Box>
    ))}
  </Box>
)

export default HowToUse
